import React from 'react';

const Badge = ({ children, variant = 'default', className = '', ...props }) => {
  const getVariantClasses = (variant) => {
    switch (variant) {
      case 'primary': return 'bg-blue-100 text-blue-800';
      case 'success': return 'bg-green-100 text-green-800';
      case 'warning': return 'bg-yellow-100 text-yellow-800';
      case 'danger': return 'bg-red-100 text-red-800';
      case 'P1': return 'bg-red-100 text-red-800';
      case 'P2': return 'bg-yellow-100 text-yellow-800';
      case 'P3': return 'bg-green-100 text-green-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const classes = `inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getVariantClasses(variant)} ${className}`;

  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
};

export default Badge; 